import { AxiosError, isAxiosError } from 'axios';

interface IGetJobPostingInsufficientAccessErrorResponse {
  error: string;
}

export class GetJobPostingInsufficientAccessError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'GetJobPostingInsufficientAccessError';
  }

  static fromAxiosError(error: unknown): GetJobPostingInsufficientAccessError | null {
    if (!isAxiosError(error)) {
      return null;
    }

    const axiosError = error as AxiosError<IGetJobPostingInsufficientAccessErrorResponse>;

    if (axiosError.response?.status === 403) {
      const errorMessage =
        axiosError.response?.data?.error ||
        axiosError.message ||
        'insufficient access to job posting';

      return new GetJobPostingInsufficientAccessError(errorMessage);
    }

    return null;
  }
}
